import React from 'react';
import Reflux from 'reflux';
import Modal from 'shared/components/misc/modal.jsx';
import UIRegions from 'shared/constants/UIRegions';
import ExportForm from 'shared/components/show/exportForm';

const title = (
  <span>
    Advanced Export
    <a
      className="learn-more-link"
      target="_blank"
      href="https://shoflo.tv/advancedexport"
    >
      Learn More
    </a>
  </span>
);

/**
 * Export Form Modal
 *
 */
export default React.createClass({
  mixins: [Reflux.ListenerMixin],

  displayName: 'ExportModal',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    return (
      <Modal
        className="modal-generic-wrapper export-modal"
        headerClassName="modal-generic-header"
        name={UIRegions.ExportForm}
        title={title}
      >
        <div className="export-modal">
          <ExportForm />
        </div>
      </Modal>
    );
  },
});
